import { render, staticRenderFns } from "./CaseMoreInfo.vue?vue&type=template&id=65536ab7&"
import script from "./CaseMoreInfo.vue?vue&type=script&lang=js&"
export * from "./CaseMoreInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports